export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=b1e4a91e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-header/notifications/index.vue?vue&type=template&id=b1e4a91e&
// module id = 1302
// module chunks = 0